import { CANVAS_LINE_HEIGHT, CANVAS_LONG_WIDTH, CANVAS_SHORT_WIDTH } from 'src/features/statistics/utils/constants';

export const canvasDisplaySpecifics = (canvas: HTMLCanvasElement, receiptTextLines: string[] | undefined) => {
    const ctx = canvas.getContext('2d');
    if (!ctx || !receiptTextLines) return;

    const longestLine = receiptTextLines.reduce((acc, line) => (line.length > acc ? line.length : acc), 0);
    const canvasWidth = longestLine > 40 ? CANVAS_LONG_WIDTH : CANVAS_SHORT_WIDTH;

    canvas.width = canvasWidth;
    canvas.height = CANVAS_LINE_HEIGHT * receiptTextLines.length + CANVAS_LINE_HEIGHT;

    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvasWidth, CANVAS_LINE_HEIGHT * receiptTextLines.length + CANVAS_LINE_HEIGHT);

    for (let i = 0; i < receiptTextLines.length; i++) {
        const line = receiptTextLines[i];
        ctx.fillStyle = '#111827';
        ctx.font = '12px IBM Plex Mono';
        ctx.textAlign = 'center';
        ctx.fillText(line, canvasWidth / 2, 25 + i * CANVAS_LINE_HEIGHT);
    }
};

export const generateCanvas = (receiptTextLines: string[] | undefined, isLoadedFont: boolean): HTMLCanvasElement => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx || !receiptTextLines || !isLoadedFont) return canvas;

    canvasDisplaySpecifics(canvas, receiptTextLines);
    return canvas;
};

export const downloadReceipt = (canvas: HTMLCanvasElement, fileName: string) => {
    if (!canvas) return;
    const url = canvas.toDataURL('image/jpeg');
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.jpg`;
    link.click();
};
